<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Tax' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <form novalidate [formGroup]="taxForm">
          <div class="form-group">
            <label for="name" class="control-label">
              {{ 'Name' | translate }} *
            </label>
            <input
              #taxName
              type="text"
              class="form-control data-hj-whitelist"
              tabindex="0"
              id="name"
              formControlName="name"
              [class.is-invalid]="
                sent && taxForm.controls.name.hasError('required')
              "
            />
            <span
              class="invalid-feedback"
              *ngIf="sent && taxForm.controls.name.hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="abbreviation" class="control-label">
              {{ 'Abbrev.' | translate }} *
            </label>
            <input
              type="text"
              class="form-control data-hj-whitelist"
              tabindex="0"
              id="abbreviation"
              formControlName="abbreviation"
              [class.is-invalid]="
                sent && taxForm.controls.abbreviation.hasError('required')
              "
            />
            <span
              class="invalid-feedback"
              *ngIf="sent && taxForm.controls.abbreviation.hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div formArrayName="_taxRates">
            <div
              *ngFor="
                let taxRate of taxForm.controls['_taxRates']['controls'];
                let i = index
              "
              [formGroup]="taxForm.get('_taxRates.' + i)"
            >
              <div class="form-group">
                <label for="rate" class="control-label">
                  {{ 'Rate' | translate }} *
                </label>
                <input
                  type="text"
                  class="form-control data-hj-whitelist"
                  tabindex="0"
                  id="rate"
                  [class.is-invalid]="
                    sent &&
                    taxForm.get('_taxRates.' + i + '.rate').hasError('required')
                  "
                  formControlName="rate"
                />
                <span
                  class="invalid-feedback"
                  *ngIf="
                    sent &&
                    taxForm.get('_taxRates.' + i + '.rate').hasError('required')
                  "
                >
                  {{ 'global.validators.required.error' | translate }}</span
                >
              </div>
            </div>
          </div>

          <!-- Advanced -->
          <button
            class="btn btn-link text-muted p-0"
            type="button"
            (click)="showAdvanced = !showAdvanced"
          >
            {{ 'taxes.tax-add.advanced.btn-text' | translate }}
            <i
              class="fe"
              [class.fe-arrow-down]="!showAdvanced"
              [class.fe-arrow-up]="showAdvanced"
            ></i>
          </button>

          <ng-container *ngIf="showAdvanced">
            <!-- Tax number -->
            <div class="form-group mt-3">
              <label for="taxNumber" class="control-label">
                {{ 'taxes.tax-add.tax-number.label' | translate }}
              </label>
              <input
                type="text"
                class="form-control data-hj-whitelist"
                tabindex="0"
                id="taxNumber"
                formControlName="taxNumber"
              />
            </div>
            <!--// Tax number -->

            <!-- Country -->
            <div class="form-group mb-0">
              <label for="country" class="control-label">
                {{ 'taxes.tax-add.country.label' | translate }}
              </label>
              <select
                name="country"
                id="country"
                class="form-control"
                formControlName="country"
              >
                <option value="">{{ activeOrg?.country }}</option>
                <option [value]="c.name" *ngFor="let c of countries$ | async">
                  {{ c.name }}
                </option>
              </select>
            </div>
            <!--// Country -->
          </ng-container>
          <!--// Advanced -->
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span *ngIf="!tax || !tax.id; else updating">{{
        'global.save' | translate
      }}</span>
      <ng-template #updating>{{ 'Update' | translate }}</ng-template>
    </button>
  </div>
</div>
